import React, { Component, Fragment } from 'react';
import MetaTags from 'react-meta-tags';
import Header from '../layouts/Header';
// import Footer from '../layouts/Footer';
// import Breadcrumbs from '../layouts/Breadcrumbs';
import { Link } from 'react-router-dom';
// import Content from '../sections/careers/Content';

// import illustration from '../../assets/img/illustration/man-with-earth-02.png';
import illustration from '../../assets/img/404.png';

class ErrorPage extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    {/* <title></title> */}
                    <meta
                        name="description"
                        content="404"
                    />
                    <meta name="title" description="404" />
                </MetaTags>
                <Header />
                {/* <Breadcrumbs breadcrumb={{ pagename: '404' }} /> */}
                <section className="contact-section contact-page section-gap-top">
                    <div className="container">
                        <div className="contact-info">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 order-2 order-lg-1">
                                    <div className="illustration-img text-center">
                                        <img src={illustration} alt="" />
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-10 order-1 order-lg-2">
                                    <div className="contact-info-content">
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <div className="section-title left-border mb-40">
                                            <span className="title-tag">Uh oh...</span>
                                            {/* <h2 className="title">Need Any Help For Business &amp; Consulting</h2> */}
                                        </div>
                                        <p>
                                            We're sorry. <br /> The page you are looking for cannot be found...
                                        </p>
                                        <ul>

                                            <li className="phone">
                                                <Link to="/"><i className="far fa-home" />Go back home</Link>
                                            </li>
                                            {/* <li><i className="far fa-envelope-open" /><Link to="#">iinfo@jwoliver.com</Link></li> */}
                                            {/* <li><i className="far fa-map-marker-alt" />Broklyn Street USA</li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                {/* <Footer /> */}
            </Fragment>
        );
    }
}

export default ErrorPage;